"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_EQUIPMENT_VALUES = exports.ALL_EQUIPMENT = exports.EQUIPMENT_DESCRIPTION_MAP = void 0;
exports.EQUIPMENT_DESCRIPTION_MAP = [
    { value: 'bodyWeight', description: 'Body Weight' },
    { value: 'chair', description: 'Chair' },
    { value: 'door', description: 'Door' },
    { value: 'pillow', description: 'Pillow' },
    { value: 'wall', description: 'Wall' },
    { value: 'dumbbell', description: 'Dumbbell' },
    { value: 'kettlebell', description: 'Kettlebell' },
    { value: 'kettlebellOrDumbbell', description: 'Kettlebell or Dumbbell' },
    { value: 'band', description: 'Band' },
    { value: 'loopedBand', description: 'Looped Band' },
    { value: 'mat', description: 'Mat' },
    { value: 'step', description: 'Step' },
    { value: 'foamRoller', description: 'Foam Roller' },
    { value: 'ball', description: 'Tennis Ball (or Similar)' },
];
exports.ALL_EQUIPMENT = exports.EQUIPMENT_DESCRIPTION_MAP.reduce((accum, e) => {
    accum[e.value] = e.description;
    return accum;
}, {});
exports.ALL_EQUIPMENT_VALUES = Object.keys(exports.ALL_EQUIPMENT);
//# sourceMappingURL=Equipment.js.map